import { formatNumber } from '../utilities';

const AVG_OFFICE_DAYS_WEEK        = 5;
const AVG_OFFICE_DAYS_MONTH       = 31;
const AVG_BANDWIDTH_PER_CALL_MBPS = 1.33; // Mbps
const AVG_DATA_USED_PER_CALL_MBPS = 600;  // Mbps per hour

const $elements = {
	tool:           document.querySelector( '.broadband-checker' ),
	calculator:     document.querySelector( '.broadband-checker__calculator' ),
	questions:      document.querySelectorAll( '.broadband-checker__question' ),
	content:        document.querySelector( '.broadband-checker__shortcode-content' ),
	results:        document.querySelector( '.broadband-checker__results' ),
	resultTemplate: document.querySelector( '#broadband-checker-result-template' ),
	formTrigger:    document.querySelector( '.broadband-checker__form-trigger' ),
	reset:          document.querySelector( '.broadband-checker__reset' ),
	form:           document.querySelector( '.broadband-checker__form' ),
	gravityForm:    false,
};

const bindQuestionInputToValue = ( element ) => {
	let input = element.querySelector( '.broadband-checker__question__input input[type="range"]' );
	let value = element.querySelector( '.broadband-checker__question__value' );

	if ( ! input || ! value ) {
		return;
	}

	input.addEventListener(
		'input',
		function () {
			let text     = this.value;
			let property = 'value';

			if ( value.dataset.hasOwnProperty( 'prefix' ) && value.dataset.prefix ) {
				text = value.dataset.prefix + text;
			}

			if ( value.dataset.hasOwnProperty( 'suffix' ) && value.dataset.suffix ) {
				text = text + value.dataset.suffix;
			}

			if ( value.classList.contains( 'broadband-checker__question__value--static' ) ) {
				property = 'textContent';
			}

			value[ property ] = text;
		}
	);

	value.addEventListener(
		'change',
		function () {
			input.value = this.value;
		}
	)
};

const replaceElementTextWithResults = ( replacements ) => {

	if ( ! $elements.content || ! replacements ) {
		return;
	}

	let markup = $elements.resultTemplate.innerHTML;

	for ( let pattern in replacements ) {
		markup = markup.replaceAll( pattern, `<span class="value">${replacements[ pattern ]}</span>` );
	}

	$elements.content.innerHTML = markup;

};

const replaceDynamicFormValues = ( replacements ) => {

	if ( ! $elements.form || ! replacements ) {
		return;
	}

	for ( let pattern in replacements ) {
		let field = $elements.form.querySelector( `input[type="hidden"][value="${pattern}"]` );

		if ( ! field ) {
			continue;
		}

		field.value = replacements[ pattern ];
	}

};

const calculateBroadbandRequirements = ( people, hours, percentage ) => {

	let perDay, perWeek, perMonth, peak;

	people     = parseInt( people );
	hours      = parseInt( hours );
	percentage = parseInt( percentage ) / 100;

	/**
	 * Calculate the per day usage, multiply it by the client average, and then
	 * reduce the number to represent gigabytes instead of megabytes.
	 */
	perDay =  people * ( hours * percentage );
	perDay *= AVG_DATA_USED_PER_CALL_MBPS;
	perDay /= 1000;
	const perDayFormatted = formatNumber( perDay );

	/**
	 * Set usage per week and per month from per day.
	 */
	perWeek  = formatNumber( perDay * AVG_OFFICE_DAYS_WEEK );
	perMonth = formatNumber( perDay * AVG_OFFICE_DAYS_MONTH );

	/**
	 * Calculate the peak usage per day from the client's averages.
	 */
	peak = formatNumber( people * AVG_BANDWIDTH_PER_CALL_MBPS );

	return {
		peak,
		perDay: perDayFormatted,
		perWeek,
		perMonth,
	};

};

const handleFormSubmission = function ( event ) {

	event.preventDefault();

	let formData     = new FormData( event.target );
	let people       = formData.get( 'peoplePerOffice' );
	let hours        = formData.get( 'hoursPerDay' );
	let percentage   = formData.get( 'virtualPercentage' );
	let results      = calculateBroadbandRequirements( people, hours, percentage );

	let replacements = {
		'{people}'     : people,
		'{hours}'      : hours,
		'{percentage}' : percentage + '%',
		'{perDay}'     : results.perDay + 'GB',
		'{perWeek}'    : results.perWeek + 'GB',
		'{perMonth}'   : results.perMonth + 'GB',
		'{peak}'       : results.peak + 'Mbps',
	};

	$elements.calculator.style.display = 'none';

	if ( $elements.formTrigger && $elements.form ) {
		window.jQuery( document ).on(
			'gform_confirmation_loaded',
			function ( event, form_id ) {
				replaceElementTextWithResults( replacements );
				replaceDynamicFormValues( replacements );
			}
		);

		$elements.form.style.display = 'block';
	} else {
		replaceElementTextWithResults( replacements );
		replaceDynamicFormValues( replacements );

		$elements.results.style.display = 'block';
	}

	return false;

};

const handleToolReset = function () {

	$elements.calculator.querySelector( 'form' ).reset();

	$elements.calculator.style.display = 'block';
	$elements.results.style.display    = 'none';

	if ( $elements.formTrigger && $elements.form ) {
		handleFormReset( $elements.form.dataset.formId );
	}

};

const handleFormReset = () => {

	if ( false === $elements.gravityForm ) {
		return;
	}

	let id     = $elements.gravityForm.id;
	let markup = $elements.gravityForm.markup;

	if ( ! id || ! markup ) {
		return;
	}

	$elements.gravityForm.instance.find( '.gform_confirmation_message_' + id ).wrap( '<div />' ).parent().html( markup );
	$elements.gravityForm.instance.find( '#gform_wrapper_' + id ).unwrap();

	window.jQuery( document ).trigger(
		'gform_post_render',
		[ $elements.gravityForm.id, 0 ]
	);

};

const createGravityFormResetData = ( id ) => {

	let $form = window.jQuery( '#gform_wrapper_' + id ).parent();
	
	if ( ! $form.length ) {
		return;
	}

	$elements.gravityForm = {
		id:       id,
		instance: $form,
		markup:   $form.html(),
	};
};

const setupBroadbandCheck = () => {

	if ( ! $elements.tool ) {
		return;
	}

	$elements.questions.forEach( element => {
		bindQuestionInputToValue( element );
	} );

	$elements.calculator.addEventListener( 'submit', handleFormSubmission );
	$elements.reset.addEventListener( 'click', handleToolReset );

	if ( $elements.formTrigger && $elements.form ) {
		createGravityFormResetData( $elements.form.dataset.formId );

		window.jQuery( document ).on(
			'gform_confirmation_loaded',
			function ( event, form_id ) {
				$elements.form.style.display    = 'none';
				$elements.results.style.display = 'block';
			}
		);
	}

};

export {
	setupBroadbandCheck,
};
